import InfoCard from "../../../../../CommonElements/InfoCard";
import { Row } from "reactstrap";
import { ManagerZoneSummaryCards } from "../../../../../Types/PettyCash";

export interface IExpenseSummaryCardsProps {
  pettyCashDetails: ManagerZoneSummaryCards[];
  pettyCashListLoading: boolean;
}

const ExpenseSummaryCards = ({
  pettyCashDetails,
  pettyCashListLoading,
}: IExpenseSummaryCardsProps) => {
  return (
    <Row className="pt-4 pt-xl-0">
      {pettyCashDetails.map((pc, idx) => (
        <InfoCard
          key={idx}
          loading={pettyCashListLoading}
          label={pc.label}
          value={pc.value ? pc.value : 0}
          {...(pc.iconClassname && { iconClassname: pc.iconClassname })}
        />
      ))}
    </Row>
  );
};

export default ExpenseSummaryCards;
